export interface ProductPriceInfo {
  amount: number;
  formatted: string;
}

export const productPriceInfoFromResponse = (
  responseData: any,
): ProductPriceInfo => ({
  amount: responseData.amount,
  formatted: responseData.formatted,
});
